import http from "@/settings/apiSettings"

class DOC_LiniiDataService {
    save(documentId: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.post(`/DOC_Linii/${documentId}`, data);
    }

    update(linieId: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.put(`/DOC_Linii/${linieId}`, data)
    }

    preiaDinComenzi(documentId: string, comandaIds: string[]): Promise<any> {
        return http.clientDocumente.post(`/DOC_Linii/${documentId}/preia-din-comenzi`, { ComandaIds: comandaIds });
    }
    preiaDinDocumentAsociat(documentId: string): Promise<any> {
        return http.clientDocumente.post(`/DOC_Linii/${documentId}/preia-din-document-asociat`, {});
    }
}
export default new DOC_LiniiDataService();